import { useQuery } from "react-query";
import { getLineOfBusiness } from "../../../../../actions/Utilities/LineOfBusiness";
const useGetLineOfBusiness = () => {
  return useQuery("GetLineOfBusiness", getLineOfBusiness, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};

export default useGetLineOfBusiness;
